import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import * as jqueryProxy from 'jquery'; const $: JQueryStatic = (<any>jqueryProxy).default || jqueryProxy;

@Directive({
    selector: '[chassisSortable]'
})
export class SortableDirective implements OnInit {

    @Input() chassisSortable;
    @Input() chassisSortableOptions: Object = {};
    @Input() chassisSortableOrderKey: string;

    constructor(private el: ElementRef) {

    }

    public ngOnInit() {

        console.log('init sortable directive', this.chassisSortableOptions, this.chassisSortable);

        const options = $.extend({
            axis: 'y',
            handle: '.handle',
            cancel: '',
            start: (e, ui) => {
                const height = ui.item.innerHeight();
                $('> td', ui.placeholder).css('height', height);
                // throw new Error('test');
            },
            update: (e, ui) => {
                console.info('order updated', ui.item.index(), e, ui);
            },
            create: (e, ui) => {

                // TODO: make sure the order is changed in the collection/Array as well
                // setTimeout(() => {
                //     $('tr', this.el.nativeElement).each(function () {
                //         console.log('item', this);
                //         this.data('')
                //     });
                // }, 100);

            }
        }, this.chassisSortableOptions);

        (<any>$(this.el.nativeElement)).sortable(options);

    }

    protected changeOrder() {

        // let items = this.chassisSortable instanceof ApiCollection ? this.chassisSortable.all() : this.chassisSortable;


    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/directives/sortable.directive.ts